var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSearchDarkIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_11236",
    "data-name": "Group 11236",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20.217,
    height: 20.209,
    viewBox: "0 0 20.217 20.209",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4121",
    "data-name": "Rectangle 4121",
    width: 20.217,
    height: 20.209,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11235",
    "data-name": "Group 11235",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1352",
    "data-name": "Path 1352",
    d: "M17.154,6.915A9.146,9.146,0,0,0,16.162,4.3a8.782,8.782,0,0,0-.874-1.231,8.68,8.68,0,0,0-1.681-1.53A8.109,8.109,0,0,0,10.987.315,8.426,8.426,0,0,0,6.882.2,8.57,8.57,0,0,0,.8,5.033a8.472,8.472,0,0,0-.674,5.019,8.578,8.578,0,0,0,1.254,3.271,8.536,8.536,0,0,0,1.865,2.1,9.742,9.742,0,0,0,1.62,1.021,7.908,7.908,0,0,0,2.632.822A8.767,8.767,0,0,0,10.2,17.2a8.6,8.6,0,0,0,3.356-1.369c.081-.057.161-.115.241-.175h0a14.439,14.439,0,0,0,1.5-1.408h0a.171.171,0,0,1,.04-.063l.048-.055,0,0h0a7.235,7.235,0,0,0,.858-1.272,8.655,8.655,0,0,0,1.021-3.038,8.513,8.513,0,0,0-.114-2.906M8.7,15.892a7.221,7.221,0,1,1,7.2-7.21,7.232,7.232,0,0,1-7.2,7.21",
    transform: "translate(0 0.001)",
    fill: "#393939"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1353",
    "data-name": "Path 1353",
    d: "M235.261,242.566a.685.685,0,0,1-.773-.029,2.363,2.363,0,0,1-.233-.213l-4.519-4.517c-.021-.021-.044-.04-.064-.059-.169.127-.329.253-.49.374a14.44,14.44,0,0,0,1.5-1.408c-.009.036.01.066.052.108q2.292,2.273,4.579,4.552a.882.882,0,0,1,.279.466.737.737,0,0,1-.329.726",
    transform: "translate(-215.382 -222.462)",
    fill: "#0094d1"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchDarkIcon);
export default __webpack_public_path__ + "static/media/search-dark-icon.6e63894005ecb25a0bee6facd2ec84b0.svg";
export { ForwardRef as ReactComponent };